import { types } from "mobx-state-tree";
const volatileStepModel = types
    .model({})
    .volatile(() => ({ props: {} }))
    .actions((self) => ({
    set: (step) => {
        self.props = step;
    },
}));
export const wizardStateModel = types
    .model({
    registeredSteps: types.map(volatileStepModel),
    activeStepId: types.maybe(types.string),
    stepsList: types.array(types.string),
})
    .views((self) => ({
    get steps() {
        return self.stepsList
            .map((id) => self.registeredSteps.get(id)?.props)
            .filter((p) => !!p)
            .filter((p) => p.hidden !== true);
    },
}))
    .views((self) => ({
    isActiveStep: (stepId) => self.activeStepId === stepId && self.steps.some((s) => s.id === stepId),
    get activeStep() {
        return self.activeStepId
            ? self.registeredSteps.get(self.activeStepId)?.props
            : undefined;
    },
    getIdOfStep: (index) => {
        return self.steps[index]?.id;
    },
    get activeStepIndex() {
        return self.steps.findIndex((s) => s.id === self.activeStepId);
    },
}))
    .views((self) => ({
    get hasNextStep() {
        return self.activeStepIndex < self.steps.length - 1;
    },
    get hasPreviousStep() {
        return self.activeStepIndex > 0;
    },
}))
    .actions((self) => ({
    removeStep: (id) => {
        self.registeredSteps.delete(id);
    },
    gotoStep: (idOrIndex) => {
        if (typeof idOrIndex === "number") {
            const id = self.getIdOfStep(idOrIndex);
            if (id) {
                self.activeStepId = id;
            }
        }
        else if (self.stepsList.includes(idOrIndex)) {
            self.activeStepId = idOrIndex;
        }
    },
}))
    .actions((self) => ({
    registerStep: (step) => {
        const model = self.registeredSteps.get(step.id) ?? volatileStepModel.create();
        model.set(step);
        self.registeredSteps.set(step.id, model);
        if (self.activeStepId === undefined) {
            self.gotoStep(0);
        }
    },
    updateStepsList: (steps) => {
        self.stepsList.replace(steps);
        if (self.activeStepId === undefined) {
            self.gotoStep(0);
        }
    },
    gotoNextStep: () => {
        self.gotoStep(self.activeStepIndex + 1);
    },
    gotoPreviousStep: () => {
        self.gotoStep(self.activeStepIndex - 1);
    },
}));
//# sourceMappingURL=data:application/json;base64,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